module.exports = __webpack_public_path__ + "static/media/bheart.c2c6ac58.png";